import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-plus-blue",
  "use": "circle-plus-blue-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle-plus-blue\">\n<circle cx=\"9.5\" cy=\"9.5\" r=\"9.5\" fill=\"#868686\" fill-opacity=\"0.2\" />\n<path d=\"M13.472 10.28H10.448V13.384H8.336V10.28H5.312V8.328H8.336V5.224H10.448V8.328H13.472V10.28Z\" fill=\"#03ADEF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol